module.exports = __webpack_public_path__ + "img/Weapon_36.5125a05d.png";